/**
 * Generated bundle index. Do not edit.
 */

export * from './public-api';

export {GrabFlightPriceDetailsComponent as ɵb} from './lib/grab-flight-price-details/grab-flight-price-details.component';
export {GrabPnrDetailsComponent as ɵa} from './lib/grab-pnr-details/grab-pnr-details.component';